import React from 'react';

export const AiGiftIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="32" height="33" viewBox="0 0 32 33" fill="none">
    <path
      d="M16 11.1666V28.5M16 11.1666C15.5177 9.17918 14.6873 7.47999 13.617 6.29079C12.5467 5.10159 11.2862 4.4775 10 4.49991C9.11595 4.49991 8.2681 4.8511 7.64298 5.47622C7.01786 6.10134 6.66667 6.94919 6.66667 7.83324C6.66667 8.7173 7.01786 9.56515 7.64298 10.1903C8.2681 10.8154 9.11595 11.1666 10 11.1666M16 11.1666C16.4823 9.17918 17.3127 7.47999 18.383 6.29079C19.4533 5.10159 20.7138 4.4775 22 4.49991C22.8841 4.49991 23.7319 4.8511 24.357 5.47622C24.9821 6.10134 25.3333 6.94919 25.3333 7.83324C25.3333 8.7173 24.9821 9.56515 24.357 10.1903C23.7319 10.8154 22.8841 11.1666 22 11.1666M25.3333 16.5V25.8333C25.3333 26.5406 25.0524 27.2188 24.5523 27.7189C24.0522 28.219 23.3739 28.5 22.6667 28.5H9.33333C8.62609 28.5 7.94781 28.219 7.44772 27.7189C6.94762 27.2188 6.66667 26.5406 6.66667 25.8333V16.5M5.33333 11.1666H26.6667C27.403 11.1666 28 11.7636 28 12.5V15.1666C28 15.903 27.403 16.5 26.6667 16.5H5.33333C4.59695 16.5 4 15.903 4 15.1666V12.5C4 11.7636 4.59695 11.1666 5.33333 11.1666Z"
      stroke="#4900FF"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M16 11.1666V28.5M16 11.1666C15.5177 9.17918 14.6873 7.47999 13.617 6.29079C12.5467 5.10159 11.2862 4.4775 10 4.49991C9.11595 4.49991 8.2681 4.8511 7.64298 5.47622C7.01786 6.10134 6.66667 6.94919 6.66667 7.83324C6.66667 8.7173 7.01786 9.56515 7.64298 10.1903C8.2681 10.8154 9.11595 11.1666 10 11.1666M16 11.1666C16.4823 9.17918 17.3127 7.47999 18.383 6.29079C19.4533 5.10159 20.7138 4.4775 22 4.49991C22.8841 4.49991 23.7319 4.8511 24.357 5.47622C24.9821 6.10134 25.3333 6.94919 25.3333 7.83324C25.3333 8.7173 24.9821 9.56515 24.357 10.1903C23.7319 10.8154 22.8841 11.1666 22 11.1666M25.3333 16.5V25.8333C25.3333 26.5406 25.0524 27.2188 24.5523 27.7189C24.0522 28.219 23.3739 28.5 22.6667 28.5H9.33333C8.62609 28.5 7.94781 28.219 7.44772 27.7189C6.94762 27.2188 6.66667 26.5406 6.66667 25.8333V16.5M5.33333 11.1666H26.6667C27.403 11.1666 28 11.7636 28 12.5V15.1666C28 15.903 27.403 16.5 26.6667 16.5H5.33333C4.59695 16.5 4 15.903 4 15.1666V12.5C4 11.7636 4.59695 11.1666 5.33333 11.1666Z"
      stroke="url(#paint0_linear_54579_8463)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_54579_8463"
        x1="-3.95"
        y1="35.2606"
        x2="40.1194"
        y2="25.5054"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4900FF" />
        <stop offset="0.462476" stopColor="#D500FF" />
        <stop offset="1" stopColor="#FF9257" />
      </linearGradient>
    </defs>
  </svg>
);
